import type { PayloadAction } from '@reduxjs/toolkit';

import type { ProcessSessionWithChildren } from '~/common/model/worker/process';

import type { SessionManagerState } from './_state.type';

/** SessionManager Reducer. */
export const sessionManagerReducer = {
  /**
   * SessionManager setOpen.
   *
   * @param {SessionManagerState} state State.
   * @param {PayloadAction<boolean>} action Action.
   */
  sessionManager_setOpen: (state: SessionManagerState, { payload }: PayloadAction<boolean>) => {
    state.sessionManager.open = payload;
  },

  /**
   * SessionManager setSession.
   *
   * @param {SessionManagerState} state State.
   * @param {PayloadAction<ProcessSessionWithChildren[]>} action Action.
   */
  sessionManager_setSessions: (state: SessionManagerState, { payload }: PayloadAction<ProcessSessionWithChildren[]>) => {
    state.sessionManager.isSync = true;
    state.sessionManager.sessions = payload;
  },
};
